import { useMutationSetReportAccessStatus } from 'api/mutations/setReportAccessStatus.mutation';
import { useQueryGetReportAccess } from 'api/queries/getReportAccessStatus.query';
import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseReportSettingsModalProvider = ReturnType<typeof useReportSettingsModalProvider>;

interface Props {
    reportId: string;
}

export const useReportSettingsModalProvider = ({ reportId }: Props) => {
    const getReportsTags = useQueryGetReportsTags();
    const getAccessStatus = useQueryGetReportAccess({
        id: Number(reportId),
    });
    const setReportAccessStatus = useMutationSetReportAccessStatus();

    return {
        api: {
            getReportsTags,
            setReportAccessStatus: {
                instance: setReportAccessStatus,
            },
            getAccessStatus,
        },
    };
};
